/**
 * This function converts a CloudFront base64 encoded string to a base64 encoded string.
 * AWS CloudFront uses a different custom encoding: + → -, = → _, / → ~.
 */

export function cloudFrontBase64ToBase64(base64url: string): string {
  return base64url.replace(/-/g, '+').replace(/_/g, '=').replace(/~/g, '/');
}
